// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-1a4e764e] .v-application--is-rtl{direction:rtl}", ""]);
// Exports
module.exports = exports;
